import { dom, library } from '@fortawesome/fontawesome-svg-core';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { fas } from '@fortawesome/free-solid-svg-icons';
export const getFontawesomeIconsCss = () => {
    // config.autoReplaceSvg = true;
    // config.observeMutations = true;
    library.add(fas, far, fab);
    return dom.css();
};
